function domReady(fn) {
  if (document.readyState !== 'loading') {
    fn();
    return;
  }
  document.addEventListener('DOMContentLoaded', fn);
}

function extendObj(obj1, obj2) {
  const _extends = Object.assign || function (target) {
    for (let i = 1; i < arguments.length; i += 1) {
      const source = arguments[i];
      for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };

  return _extends({}, obj1, obj2);
}

// Used for htaccess auth on the protected staging server.
function authenticate() {
  const credentials = 'raggededge:staging1305';
  const hash = window.btoa(credentials);
  return `Basic ${hash}`;
}

function shuffle(array) {
  let i = 0;
  let j = 0;
  let temp = null;

  for (i = array.length - 1; i > 0; i -= 1) {
    j = Math.floor(Math.random() * (i + 1));
    temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }

  return array;
}

function randomNumber(from, to) {
  return Math.floor(Math.random() * to) + from;
}

function isElementInViewport(el, partial = false) {
  const rect = el.getBoundingClientRect();

  if (partial) {
    return (
      rect.top >= 0 &&
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left >= 0
    );
  }

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function truncateWords(sentence = '', amount, tail) {
  if (!sentence || !sentence.length) {
    return '';
  }

  const words = sentence.split(' ');

  if (amount >= words.length) {
    return sentence;
  }

  const truncated = words.slice(0, amount);
  return `${truncated.join(' ')}${tail}`;
}

function parseUris(text) {
  return text.replace(/[A-Za-z]+:\/\/[A-Za-z0-9-_]+\.[A-Za-z0-9-_:%&\?\/.=]+/g, uri => `<a href="${uri}" target="_blank" rel="noopener">${uri}</a>`);
}

function parseFacebook(text) {
  // Parse URIs
  text = parseUris(text);

  // Parse Facebook hash tags
  text = text.replace(/[#]+[A-Za-z0-9-_]+/g, (t) => {
    const tag = t.replace('#', '');
    return `<a href="https://www.facebook.com/hashtag/${tag}" target="_blank" rel="noopener">${t}</a>`;
  });

  return text;
}

function parseTwitter(text) {
  // Parse URIs
  text = parseUris(text);

  // Parse Twitter usernames
  text = text.replace(/[@]+[A-Za-z0-9-_]+/g, (u) => {
    const username = u.replace('@', '');
    return `<a href="https://twitter.com/${username}" target="_blank" rel="noopener">${u}</a>`;
  });

  // Parse Twitter hash tags
  text = text.replace(/[#]+[A-Za-z0-9-_]+/g, (t) => {
    const tag = t.replace('#', '%23');
    return `<a href="https://twitter.com/search?q=${tag}" target="_blank" rel="noopener">${t}</a>`;
  });

  return text;
}

export {
  shuffle,
  randomNumber,
  domReady,
  authenticate,
  isElementInViewport,
  extendObj,
  truncateWords,
  parseFacebook,
  parseTwitter
};
